// import React, { useState, useEffect } from "react";
// import { useDispatch } from "react-redux";
// import { toast } from "react-toastify";
// import Modal from "./Modal";
// import TextInput from "./TextInput";
// import { updatePasswordApis } from "../redux/users/userActions";
// // import { updateUserProfileApis } from "../redux/users/userActions";

// const UserProfileModal = ({ show, onClose, currentUser }) => {
//   console.log(currentUser, "currentUser 32323");

//   const dispatch = useDispatch();
//   const [isLoading, setIsLoading] = useState(false);

//   // Toggle for showing password section
//   const [isChangingPassword, setIsChangingPassword] = useState(false);

//   // Toggles for password visibility (Eye icons)
//   const [showNewPass, setShowNewPass] = useState(false);
//   const [showConfirmPass, setShowConfirmPass] = useState(false);

//   // Form Data
//   const [formData, setFormData] = useState({
//     UserName: "",
//     EMail: "",
//     Role: "",
//     C_Date: "",
//     NewPassword: "",
//     ConfirmPassword: "",
//   });

//   // --- VALIDATION LOGIC ---
//   const hasLength = formData.NewPassword.length >= 5;
//   const hasNumber = /\d/.test(formData.NewPassword);
//   const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(formData.NewPassword);
//   const isMatch =
//     formData.NewPassword.length > 0 &&
//     formData.ConfirmPassword.length > 0 &&
//     formData.NewPassword === formData.ConfirmPassword;

//   // Final check: Only matters if user is actually changing password
//   const isFormValid = isChangingPassword
//     ? hasLength && hasNumber && hasSpecial && isMatch
//     : true;

//   // Helper for UI Colors (Gray if empty, Green if met, Red if failed)
//   const getReqClass = (met) => {
//     if (formData.NewPassword.length === 0) return "text-muted";
//     return met ? "text-success fw-bold" : "text-danger";
//   };
//   // ------------------------

//   // Load data when modal opens
//   useEffect(() => {
//     if (show && currentUser) {
//       setFormData({
//         UserName: currentUser.userName || "",
//         EMail: currentUser.email || "",
//         Role: currentUser.role || "",
//         C_Date: currentUser.C_Date || "",
//         NewPassword: "",
//         ConfirmPassword: "",
//       });
//       setIsChangingPassword(false);
//       setShowNewPass(false);
//       setShowConfirmPass(false);
//     }
//   }, [show, currentUser]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     // If password, remove spaces just in case
//     const cleanValue =
//       name === "NewPassword" || name === "ConfirmPassword"
//         ? value.replace(/\s/g, "")
//         : value;

//     setFormData({ ...formData, [name]: cleanValue });
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     return new Date(dateString).toLocaleDateString("en-GB", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Validation Check
//     if (isChangingPassword && !isFormValid) {
//       toast.error("Please satisfy all password requirements.");
//       return;
//     }

//     setIsLoading(true);

//     const payload = {
//       email: currentUser.email,
//       UserName: formData.UserName,
//       resetPassowrd: true,
//       ...(isChangingPassword ? { newPassword: formData.NewPassword } : {}),
//     };
//     console.log(payload, "payload 424432");

//     // const payload = { email: emailFromUrl, newPassword: password };
//     const result = await dispatch(updatePasswordApis(payload));

//     if (result.meta.requestStatus === "fulfilled") {
//       setTimeout(() => {
//         toast.success("Profile updated successfully!");
//         setIsLoading(false);
//         onClose();
//       }, 1000);
//     }
//   };

//   // Prevent crash if data isn't loaded
//   if (!currentUser && show) return null;

//   return (
//     <Modal
//       show={show}
//       onClose={onClose}
//       title="Account Settings"
//       maxWidth="600px"
//     >
//       <form onSubmit={handleSubmit}>
//         <div className="p-4">
//           {/* Header Badge */}
//           <div className="d-flex align-items-center gap-3 mb-4 p-3 bg-light rounded-3 border">
//             <div
//               className="d-flex align-items-center justify-content-center bg-primary text-white shadow-sm rounded-circle"
//               style={{
//                 width: "56px",
//                 height: "56px",
//                 fontSize: "1.5rem",
//                 fontWeight: "bold",
//               }}
//             >
//               {formData.UserName
//                 ? formData.UserName.charAt(0).toUpperCase()
//                 : "U"}
//             </div>
//             <div>
//               <h5 className="m-0 fw-bold text-dark">
//                 {formData.UserName || "User"}
//               </h5>
//               <div className="d-flex gap-2 mt-1">
//                 <span
//                   className="badge bg-dark text-uppercase"
//                   style={{ fontSize: "0.7rem" }}
//                 >
//                   {formData.Role}
//                 </span>
//                 <span
//                   className="badge bg-white text-muted border"
//                   style={{ fontSize: "0.7rem" }}
//                 >
//                   Joined: {formatDate(formData.C_Date)}
//                 </span>
//               </div>
//             </div>
//           </div>

//           <div className="row g-3">
//             {/* --- READ ONLY FIELDS --- */}
//             <div className="col-12 col-md-6">
//               <label className="form-label fw-bold text-muted small text-uppercase">
//                 Email Address
//               </label>
//               <div className="input-group">
//                 <span className="input-group-text bg-light border-end-0 text-muted">
//                   <i className="bi bi-envelope"></i>
//                 </span>
//                 <input
//                   type="text"
//                   className="form-control bg-light border-start-0 ps-0"
//                   value={formData.EMail}
//                   disabled
//                 />
//               </div>
//             </div>

//             <div className="col-12 col-md-6">
//               <label className="form-label fw-bold text-muted small text-uppercase">
//                 Role
//               </label>
//               <div className="input-group">
//                 <span className="input-group-text bg-light border-end-0 text-muted">
//                   <i className="bi bi-shield-lock"></i>
//                 </span>
//                 <input
//                   type="text"
//                   className="form-control bg-light border-start-0 ps-0"
//                   value={formData.Role}
//                   disabled
//                 />
//               </div>
//             </div>

//             <div className="col-12">
//               <div className="border-bottom my-2"></div>
//             </div>

//             {/* --- EDITABLE USERNAME --- */}
//             <div className="col-12">
//               <TextInput
//                 width="100%"
//                 label="User Name"
//                 name="UserName"
//                 value={formData.UserName}
//                 onChange={handleChange}
//                 required
//               />
//             </div>

//             {/* --- PASSWORD CHANGE TOGGLE --- */}
//             <div className="col-12 mt-2">
//               <div className="form-check form-switch">
//                 <input
//                   className="form-check-input"
//                   type="checkbox"
//                   id="changePassSwitch"
//                   checked={isChangingPassword}
//                   onChange={(e) => setIsChangingPassword(e.target.checked)}
//                   style={{ cursor: "pointer" }}
//                 />
//                 <label
//                   className="form-check-label fw-medium cursor-pointer select-none"
//                   htmlFor="changePassSwitch"
//                 >
//                   Change Password
//                 </label>
//               </div>
//             </div>

//             {/* --- PASSWORD FIELDS (CONDITIONAL & VALIDATED) --- */}
//             {isChangingPassword && (
//               <div className="col-12 bg-white p-3 rounded border shadow-sm animate__animated animate__fadeIn">
//                 <div className="row g-3">
//                   {/* New Password Input */}
//                   <div className="col-12 col-md-6">
//                     <label className="form-label fw-bold small">
//                       New Password
//                     </label>
//                     <div className="input-group">
//                       <input
//                         type={showNewPass ? "text" : "password"}
//                         className="form-control"
//                         name="NewPassword"
//                         value={formData.NewPassword}
//                         onChange={handleChange}
//                         placeholder="Min 5 chars"
//                       />
//                       <span
//                         className="input-group-text cursor-pointer bg-white"
//                         onClick={() => setShowNewPass(!showNewPass)}
//                         style={{ cursor: "pointer" }}
//                       >
//                         <i
//                           className={`bi ${showNewPass ? "bi-eye-slash" : "bi-eye"}`}
//                         ></i>
//                       </span>
//                     </div>
//                   </div>

//                   {/* Confirm Password Input */}
//                   <div className="col-12 col-md-6">
//                     <label className="form-label fw-bold small">
//                       Confirm Password
//                     </label>
//                     <div className="input-group">
//                       <input
//                         type={showConfirmPass ? "text" : "password"}
//                         className={`form-control ${formData.ConfirmPassword && !isMatch ? "border-danger" : ""}`}
//                         name="ConfirmPassword"
//                         value={formData.ConfirmPassword}
//                         onChange={handleChange}
//                         placeholder="Repeat password"
//                       />
//                       <span
//                         className="input-group-text cursor-pointer bg-white"
//                         onClick={() => setShowConfirmPass(!showConfirmPass)}
//                         style={{ cursor: "pointer" }}
//                       >
//                         <i
//                           className={`bi ${showConfirmPass ? "bi-eye-slash" : "bi-eye"}`}
//                         ></i>
//                       </span>
//                     </div>
//                   </div>

//                   {/* VALIDATION CHECKLIST */}
//                   <div className="col-12">
//                     <div className="p-3 bg-light rounded border mt-2">
//                       <h6 className="small fw-bold text-muted text-uppercase mb-2">
//                         Password Requirements
//                       </h6>
//                       <div className="d-flex flex-wrap gap-3 small">
//                         <div className={getReqClass(hasLength)}>
//                           <i
//                             className={`bi ${hasLength ? "bi-check-circle-fill" : "bi-circle"} me-1`}
//                           ></i>{" "}
//                           Min 5 chars
//                         </div>
//                         <div className={getReqClass(hasNumber)}>
//                           <i
//                             className={`bi ${hasNumber ? "bi-check-circle-fill" : "bi-circle"} me-1`}
//                           ></i>{" "}
//                           1 Number
//                         </div>
//                         <div className={getReqClass(hasSpecial)}>
//                           <i
//                             className={`bi ${hasSpecial ? "bi-check-circle-fill" : "bi-circle"} me-1`}
//                           ></i>{" "}
//                           1 Special Char
//                         </div>
//                         <div className={getReqClass(isMatch)}>
//                           <i
//                             className={`bi ${isMatch ? "bi-check-circle-fill" : "bi-circle"} me-1`}
//                           ></i>{" "}
//                           Passwords Match
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>

//           {/* Footer Buttons */}
//           <div className="d-flex justify-content-end gap-2 mt-4 pt-3 border-top">
//             <button
//               type="button"
//               className="btn btn-light border px-4"
//               onClick={onClose}
//               disabled={isLoading}
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               className="btn btn-primary px-4 shadow-sm"
//               disabled={isLoading || (isChangingPassword && !isFormValid)}
//             >
//               {isLoading ? (
//                 <span>
//                   <span className="spinner-border spinner-border-sm me-2"></span>
//                   Saving...
//                 </span>
//               ) : (
//                 "Save Changes"
//               )}
//             </button>
//           </div>
//         </div>
//       </form>
//     </Modal>
//   );
// };

// export default UserProfileModal;





import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Modal from "./Modal";
import TextInput from "./TextInput";
import { updatePasswordApis } from "../redux/users/userActions";
import WorkStatusDropdown from "./WorkStatusDropdown"; // <-- IMPORTED HERE

const UserProfileModal = ({ show, onClose, currentUser }) => {
  console.log(currentUser, "currentUser 32323");

  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  // Toggle for showing password section
  const [isChangingPassword, setIsChangingPassword] = useState(false);

  // Toggles for password visibility (Eye icons)
  const [showNewPass, setShowNewPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);

  // Form Data
  const [formData, setFormData] = useState({
    UserName: "",
    EMail: "",
    Role: "",
    C_Date: "",
    NewPassword: "",
    ConfirmPassword: "",
  });

  // --- VALIDATION LOGIC ---
  const hasLength = formData.NewPassword.length >= 5;
  const hasNumber = /\d/.test(formData.NewPassword);
  const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(formData.NewPassword);
  const isMatch =
    formData.NewPassword.length > 0 &&
    formData.ConfirmPassword.length > 0 &&
    formData.NewPassword === formData.ConfirmPassword;

  // Final check: Only matters if user is actually changing password
  const isFormValid = isChangingPassword
    ? hasLength && hasNumber && hasSpecial && isMatch
    : true;

  // Helper for UI Colors (Gray if empty, Green if met, Red if failed)
  const getReqClass = (met) => {
    if (formData.NewPassword.length === 0) return "text-muted";
    return met ? "text-success fw-bold" : "text-danger";
  };
  // ------------------------

  // Load data when modal opens
  useEffect(() => {
    if (show && currentUser) {
      setFormData({
        UserName: currentUser.userName || "",
        EMail: currentUser.email || "",
        Role: currentUser.role || "",
        C_Date: currentUser.C_Date || "",
        NewPassword: "",
        ConfirmPassword: "",
      });
      setIsChangingPassword(false);
      setShowNewPass(false);
      setShowConfirmPass(false);
    }
  }, [show, currentUser]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    // If password, remove spaces just in case
    const cleanValue =
      name === "NewPassword" || name === "ConfirmPassword"
        ? value.replace(/\s/g, "")
        : value;

    setFormData({ ...formData, [name]: cleanValue });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation Check
    if (isChangingPassword && !isFormValid) {
      toast.error("Please satisfy all password requirements.");
      return;
    }

    setIsLoading(true);

    const payload = {
      email: currentUser.email,
      UserName: formData.UserName,
      resetPassowrd: true,
      ...(isChangingPassword ? { newPassword: formData.NewPassword } : {}),
    };
    console.log(payload, "payload 424432");

    const result = await dispatch(updatePasswordApis(payload));

    if (result.meta.requestStatus === "fulfilled") {
      setTimeout(() => {
        toast.success("Profile updated successfully!");
        setIsLoading(false);
        onClose();
      }, 1000);
    } else {
       setIsLoading(false);
    }
  };

  // Prevent crash if data isn't loaded
  if (!currentUser && show) return null;

  return (
    <Modal
      show={show}
      onClose={onClose}
      title="Account Settings"
      maxWidth="600px"
    >
      <form onSubmit={handleSubmit}>
        <div className="p-4">
          
          {/* Header Badge - UPDATED TO INCLUDE DROPDOWN */}
          <div className="d-flex align-items-center justify-content-between mb-4 p-3 bg-light rounded-3 border">
            
            {/* Left side: Avatar and Info */}
            <div className="d-flex align-items-center gap-3">
              <div
                className="d-flex align-items-center justify-content-center bg-primary text-white shadow-sm rounded-circle"
                style={{
                  width: "56px",
                  height: "56px",
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                }}
              >
                {formData.UserName
                  ? formData.UserName.charAt(0).toUpperCase()
                  : "U"}
              </div>
              <div>
                <h5 className="m-0 fw-bold text-dark">
                  {formData.UserName || "User"}
                </h5>
                <div className="d-flex gap-2 mt-1">
                  <span
                    className="badge bg-dark text-uppercase"
                    style={{ fontSize: "0.7rem" }}
                  >
                    {formData.Role}
                  </span>
                  <span
                    className="badge bg-white text-muted border"
                    style={{ fontSize: "0.7rem" }}
                  >
                    Joined: {formatDate(formData.C_Date)}
                  </span>
                </div>
              </div>
            </div>

            {/* Right side: Work Status Dropdown */}
            <div>
              <WorkStatusDropdown currentUser={currentUser} />
            </div>

          </div>

          <div className="row g-3">
            {/* --- READ ONLY FIELDS --- */}
            <div className="col-12 col-md-6">
              <label className="form-label fw-bold text-muted small text-uppercase">
                Email Address
              </label>
              <div className="input-group">
                <span className="input-group-text bg-light border-end-0 text-muted">
                  <i className="bi bi-envelope"></i>
                </span>
                <input
                  type="text"
                  className="form-control bg-light border-start-0 ps-0"
                  value={formData.EMail}
                  disabled
                />
              </div>
            </div>

            <div className="col-12 col-md-6">
              <label className="form-label fw-bold text-muted small text-uppercase">
                Role
              </label>
              <div className="input-group">
                <span className="input-group-text bg-light border-end-0 text-muted">
                  <i className="bi bi-shield-lock"></i>
                </span>
                <input
                  type="text"
                  className="form-control bg-light border-start-0 ps-0"
                  value={formData.Role}
                  disabled
                />
              </div>
            </div>

            <div className="col-12">
              <div className="border-bottom my-2"></div>
            </div>

            {/* --- EDITABLE USERNAME --- */}
            <div className="col-12">
              <TextInput
                width="100%"
                label="User Name"
                name="UserName"
                value={formData.UserName}
                onChange={handleChange}
                required
              />
            </div>

            {/* --- PASSWORD CHANGE TOGGLE --- */}
            <div className="col-12 mt-2">
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="changePassSwitch"
                  checked={isChangingPassword}
                  onChange={(e) => setIsChangingPassword(e.target.checked)}
                  style={{ cursor: "pointer" }}
                />
                <label
                  className="form-check-label fw-medium cursor-pointer select-none"
                  htmlFor="changePassSwitch"
                >
                  Change Password
                </label>
              </div>
            </div>

            {/* --- PASSWORD FIELDS (CONDITIONAL & VALIDATED) --- */}
            {isChangingPassword && (
              <div className="col-12 bg-white p-3 rounded border shadow-sm animate__animated animate__fadeIn">
                <div className="row g-3">
                  {/* New Password Input */}
                  <div className="col-12 col-md-6">
                    <label className="form-label fw-bold small">
                      New Password
                    </label>
                    <div className="input-group">
                      <input
                        type={showNewPass ? "text" : "password"}
                        className="form-control"
                        name="NewPassword"
                        value={formData.NewPassword}
                        onChange={handleChange}
                        placeholder="Min 5 chars"
                      />
                      <span
                        className="input-group-text cursor-pointer bg-white"
                        onClick={() => setShowNewPass(!showNewPass)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          className={`bi ${showNewPass ? "bi-eye-slash" : "bi-eye"}`}
                        ></i>
                      </span>
                    </div>
                  </div>

                  {/* Confirm Password Input */}
                  <div className="col-12 col-md-6">
                    <label className="form-label fw-bold small">
                      Confirm Password
                    </label>
                    <div className="input-group">
                      <input
                        type={showConfirmPass ? "text" : "password"}
                        className={`form-control ${formData.ConfirmPassword && !isMatch ? "border-danger" : ""}`}
                        name="ConfirmPassword"
                        value={formData.ConfirmPassword}
                        onChange={handleChange}
                        placeholder="Repeat password"
                      />
                      <span
                        className="input-group-text cursor-pointer bg-white"
                        onClick={() => setShowConfirmPass(!showConfirmPass)}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          className={`bi ${showConfirmPass ? "bi-eye-slash" : "bi-eye"}`}
                        ></i>
                      </span>
                    </div>
                  </div>

                  {/* VALIDATION CHECKLIST */}
                  <div className="col-12">
                    <div className="p-3 bg-light rounded border mt-2">
                      <h6 className="small fw-bold text-muted text-uppercase mb-2">
                        Password Requirements
                      </h6>
                      <div className="d-flex flex-wrap gap-3 small">
                        <div className={getReqClass(hasLength)}>
                          <i
                            className={`bi ${hasLength ? "bi-check-circle-fill" : "bi-circle"} me-1`}
                          ></i>{" "}
                          Min 5 chars
                        </div>
                        <div className={getReqClass(hasNumber)}>
                          <i
                            className={`bi ${hasNumber ? "bi-check-circle-fill" : "bi-circle"} me-1`}
                          ></i>{" "}
                          1 Number
                        </div>
                        <div className={getReqClass(hasSpecial)}>
                          <i
                            className={`bi ${hasSpecial ? "bi-check-circle-fill" : "bi-circle"} me-1`}
                          ></i>{" "}
                          1 Special Char
                        </div>
                        <div className={getReqClass(isMatch)}>
                          <i
                            className={`bi ${isMatch ? "bi-check-circle-fill" : "bi-circle"} me-1`}
                          ></i>{" "}
                          Passwords Match
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Footer Buttons */}
          <div className="d-flex justify-content-end gap-2 mt-4 pt-3 border-top">
            <button
              type="button"
              className="btn btn-light border px-4"
              onClick={onClose}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary px-4 shadow-sm"
              disabled={isLoading || (isChangingPassword && !isFormValid)}
            >
              {isLoading ? (
                <span>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Saving...
                </span>
              ) : (
                "Save Changes"
              )}
            </button>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default UserProfileModal;